import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { TripsService } from '@shared/services';
import { Constants } from '@shared/models';
import type { TTrip } from '@shared/models';

@Component({
    'selector': 'app-tracker2HistoricalTrips',
    'templateUrl': './tracker2HistoricalTrips.page.html',
    'styleUrls': ['./tracker2HistoricalTrips.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Tracker2HistoricalTripsPage extends ViewBasePage implements OnInit {
    public allTrips: TTrip[] = [];
    public filteredTrips: TTrip[] = [];
    private previousFilterData: any = null;
    private vm: any;

    constructor(private tripsService: TripsService, injector: Injector) {
        super(injector);
    }

    public async ionViewWillEnter() {
        this.vm = this.getViewModel();

        if (this.allTrips.length === 0) {
            this.allTrips = await this.getAllTrips();
        }
        // console.log(`Total trips retrieved: ${this.allTrips.length}`);

        if (this.vm?.filter !== this.previousFilterData) {
            this.filteredTrips = await this.filterTripData();
            // this.allTrips = this.vm.tripData.trips;  //await this.tripsService.getByDateRange(startRange, endRange);
        }
        // console.log(`Filtered trips: ${this.filteredTrips}`);
        this.initMoreMenu();
    }


    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-tracker-historical-2-tour');
    }
    // public ionViewWillLeave() {
    //     this.vm.tripData.trips = this.allTrips;

    //     this.setViewModel(this.vm);
    //     // this.router.navigateByUrl('/trackerHistorical/tabs/historicalTrackingTrips');
    // }

    private async getAllTrips(): Promise<TTrip[]> {
        const startRange = this.vm.filter.startingDate;
        const endRange = this.vm.filter.endingDate;

        const allTrips = await this.tripsService.getByDateRange(startRange, endRange);
        // for (let idx = 0; idx < 8; idx++) {
        //     allTrips.forEach(trip => {
        //         allTrips.push(trip);
        //     });
        // }
        return allTrips;
    }

    public async filterTripData(): Promise<TTrip[]> {
        const filteredTrips = this.applyFilter(this.allTrips);
        this.tripsService.sort(filteredTrips);

        // this.vm.filter = this.vm.filter;
        this.vm.tripData.trips = filteredTrips;
        this.setViewModel(this.vm);

        // this.uxHelperService.showAlert(`Info`, `${allTrips.length} trips found.`);
        return filteredTrips;
    }

    private applyFilter(allTrips: TTrip[]): TTrip[] {
        const trips = allTrips.filter(trip => {
            let conditionPassed = true;

            // This code was useful when I was doing a trips.getAll().  However, now that I am getting
            // all the trips within the date range, I don't need to filter by date range again.
            // if (conditionPassed) {
            //     const startingTimestamp = this.dateService.parse(this.filter.startingDate, DateTimeFormats.BigDate);
            //     conditionPassed = (trip.startTripDate >= startingTimestamp);
            // }
            // if (conditionPassed) {
            //     const endingTimestamp = this.dateService.parse(this.filter.endingDate, DateTimeFormats.BigDate);
            //     conditionPassed = (trip.endTripDate <= endingTimestamp);
            // }

            if (conditionPassed) {
                conditionPassed = (this.vm.filter.selectedDrivers === 'All Drivers' ||
                    this.vm.filter.selectedDrivers.includes(trip.driver));
            }

            // if (conditionPassed) {
            //     const tripDuration = 
            //     conditionPassed = (tripDuration > this.filter.minimumTripDurationMins);
            // }

            return conditionPassed;
        });
        return trips;
    }

    public async onNextClick() {
        super.setViewModel(this.vm);
        this.router.navigateByUrl('/tracker/tracker3HistoricalRoutes');
    }

    public getTripDate(trip: TTrip): string {
        const timestamp = trip.startTripDate;
        const str = this.dateService.formatTimestamp(timestamp, Constants.DateTimeFormats.LongDate);
        return str;
    }

    public getStartTime(trip: TTrip): string {
        const timestamp = trip.startTripDate;
        const str = this.dateService.formatTimestamp(timestamp, Constants.DateTimeFormats.ShortTime);
        return str;
    }

    public getEndTime(trip: TTrip): string {
        const timestamp = trip.endTripDate;
        const str = this.dateService.formatTimestamp(timestamp, Constants.DateTimeFormats.ShortTime);
        return str;
    }

    public getTripType(trip: TTrip): string {
        return trip.type;
    }

    public getDuration(trip: TTrip): string {
        const timestamp1 = trip.startTripDate;
        const timestamp2 = trip.endTripDate;
        const str = this.dateService.formatDuration(timestamp1, timestamp2);
        return str;
    }

    public getDriver(trip: TTrip): string {
        return trip.driver;
    }

    public getNumTickets(trip: TTrip): string {
        return trip.tickets.length.toString();
    }

    // public onTripClick(trip): void {
    //     console.log('In onTripClick');
    // }
}
